import { useEffect, useState } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../theme/Component/ListMenu";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicTable } from "../../theme/Component/BasicTable";
import { Modal } from "../../theme/Component/Modal";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { _ProductPhoto } from "../../../core/services/dataBean/EntityCatalogVdos";
import { FileService } from "../../../core/services/FileService";
import { FileInput } from "../../theme/Component/FileInput";


interface Props {
    idProduct: number;
}
export const ProductPhoto = ({ idProduct }: Props) => {

    const photo = useDataBean(_ProductPhoto);
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const fileService = new FileService();
    useEffect(() => {
        getLista();
    }, [idProduct])

    const getLista = () => {

        photo.instance.getProductPhotoCatalog(idProduct).then(
            (resp: any) => {
                if (resp) {
                    let tmp = resp;
                    tmp.forEach((element: any) => {
                        if (element.DataBeanProperties.MediaContext) {
                            element.DataBeanProperties.URL = ` <a href="${fileService.getUrlFile(element.DataBeanProperties.MediaContext, element.DataBeanProperties.Media)}" target='_blank'>DESCARGAR DOCUMENTO</a>`
                        } else {
                            element.DataBeanProperties.URL = "Sin Documento";
                        }
                    });
                    setLista(tmp);
                } else {
                    setLista([]);
                }

            }
        )

    }

    const create = () => {
        photo.setBean({
            IDProduct: idProduct
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        photo.instance.deleteProductPhoto(photo.bean.IDProductPhoto).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        photo.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDProductPhoto', visible: true },
        { title: 'Archivo', property: 'URL', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Galería de Fotos del Producto">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={photo.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">

                            <FileInput
                                label='Documento Adjunto'
                                directory='DocComercio'
                                onCreate={({ Media, MediaContext }) => { photo.setBean({ ...photo.bean, "Media": Media, "MediaContext": MediaContext }) }}
                            />
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {photo.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}